import { render, staticRenderFns } from "./EmployeeTable.vue?vue&type=template&id=33d4ed02&"
import script from "./EmployeeTable.vue?vue&type=script&lang=ts&"
export * from "./EmployeeTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports